import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-sidebar-header',
    templateUrl: './sidebar-header.component.html',
    styleUrl: './sidebar-header.component.scss',
    standalone: false,
})
export class SidebarHeaderComponent {
    @Input() isExpanded = false;
    @Input() toggleSidebar!: () => void;
}
